module.exports = __webpack_public_path__ + "img/sucMsg.e932e06e.svg";